import React from "react";
import '../style.css';

interface LoginProps {
    children: any;
}

const LoginContainer: React.FC<LoginProps> = ({ children }) => {
    return (
        <div className="min-h-screen flex flex-col lg:flex-row">
            {/* Left Panel - Content */}
            <div className="flex-1 flex justify-center items-center relative p-4 lg:w-1/2">
                {/* Logo */}
                <div className="absolute top-4 left-4 lg:top-6 lg:left-9 text-xl lg:text-2xl text-[#6941C6] font-[Montserrat Alternates] font-bold leading-normal tracking-[-1.12px] z-10">
                    Veytan
                </div>
                
                {/* Main Content */}
                <div className="w-full max-w-[400px] px-4 lg:mt-0">
                    {children}
                </div>
                
                {/* Footer Logo - Dead center at bottom for mobile */}
                {/* <div className="absolute bottom-6 left-0 right-0 flex justify-center lg:py-8 lg:bottom-0 lg:w-full">
                    <img src="/assets/login/buzzworks_logo.svg" alt="Buzzworks Logo" className="h-6 lg:h-auto" />
                </div> */}
            </div>
            
            {/* Right Panel - Image (Hidden on mobile and tablet) */}
            <div className="hidden lg:flex lg:w-1/2 items-end bg-[#540A84] relative">
                <img src="/assets/login/rightPane.svg" className="w-full h-auto" alt="Right Pane" />
            </div>
        </div>
    );
}

export default LoginContainer;